import { Col, Row } from 'antd'
import { React, useEffect, useState } from 'react'
import { categoryData1 } from '../../Utils/constants'
import Loader from '../Helpers/Loader'
import "./CategoryBox.css"
const CategoryBox = ({ heading, selectCategory, selectedCategory, categoryData }) => {

    const [loading, setLoading] = useState(true)
    let arrayToMap = []
    if (!Array.isArray(categoryData))
        arrayToMap = Object.keys(categoryData)?.map((obj) => obj)
    if (Array.isArray(categoryData))
        arrayToMap = categoryData

    useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 250);
    }, [])


    return (
        <Loader loading={loading}>
            <div className='CategoryBox'>
                <h3>{heading}</h3>
                {arrayToMap?.map((item, index) => (
                    <Row key={index}
                        className={`categoryBoxRow ${selectedCategory === index && 'selectedCategoryBoxRow'}`}
                        onClick={() => { selectCategory(index, item) }}> <Col span={24} className="categoryBoxCol" style={{ cursor: "pointer" }}>{item}</Col></Row>
                ))}
            </div>
        </Loader>
    )
}

export default CategoryBox;